angular.module('Itao.IndicatorMap').controller('ShareLinkModalController', ['$scope', '$uibModalInstance', 'data', function($scope, $uibModalInstance, data) {
  'use strict';
  // Apply categories to scope for select field
  $scope.link = data.link;
  setTimeout(function(){
    var copyTextarea = document.querySelector('#link-to-copy');
    copyTextarea.select();
  }, 100);

  $scope.copyToClipBoard = function () {
    var copyTextarea = document.querySelector('#link-to-copy');
    copyTextarea.select();
    try {
      var successful = document.execCommand('copy');
      var msg = successful ? 'successful' : 'unsuccessful';
      console.log('Copying text command was ' + msg);
    } catch (err) {
      console.log('unable to copy');
    }

    $uibModalInstance.close();
  };

  /**
   * Closes the creation modal window
   */
  $scope.close = function () {
    $uibModalInstance.dismiss('cancel');
  };
}]);
